import { HOST, registerModel } from '@/utils/base';

export default [
    // 进销存 采购
    {
        path: HOST + 'stat',
        component: () => import('@/layouts/BasicLayout'),
        beforeEnter: (to, from, next) => {
            next();
        },
        children: [
            //
            // {
            //     path: 'coop/list',
            //     component: () => import('@/routes/coop/list'),
            // },
            // //
            // {
            //     path: 'coop/add',
            //     component: () => import('@/routes/coop/add'),
            // },
        ],
    },
];



// WEBPACK FOOTER //
// ./src/common/stat_router.js